<template>
	<div class="page">

		<scroll-to :links="scrollTo"></scroll-to>


		<div class="page-content-wrap">
			

			<div class="content-place">

				<div class="row">
					<errors></errors>
				</div>


				<div class="row">
					<h3 id="s1" class="title-steps">Снимки</h3>
					<div class="col-lg-12 section-work">
						<sortableImages @exportImages="exportImages"  :images="www.images"></sortableImages>
					</div>
				</div>

				<div class="row">
					<h3 id="s2" class="title-steps">Мета дани</h3>
					<div class="col-lg-12 section-work">
						<forms v-if="this.openForms" @exportMeta="exportMeta" :formElements="formElements"></forms>
					</div>
				</div>

			<!-- 	<div class="row">
					<h3 id="s3" class="title-steps">Описание</h3>
					<div class="col-lg-12 section-work">
						<editor @exportContent="exportContent" :contentt="www.description"></editor>	
					</div>
				</div> -->
<!-- 
				<div class="row">
					<h3 id="s3" class="title-steps">Опции</h3>
					<div class="col-lg-12 section-work">
						<form-list :limit="20" :filters="www.options" :where="'soft/option/search'" @exportList="exportOptions"></form-list>
					</div>
				</div> -->



			</div>

			
		</div>
		
		<bottom-menu :www="www"></bottom-menu>
		<modal-create-folder v-if="modalCreateFolder"></modal-create-folder>

	</div>
</template>
<script>
	
	import ModalCreateFolder from "../../app_modules/ModalCreateFolder";


	import ScrollTo from '../../../components/layouts/ScrollTo'
	import Errors from '../../../components/app_modules/Errors'
	import BottomMenu from '../../../components/app_modules/BottomMenu'
	
	import SortableImages from '../../../components/app_modules/SortableImages'
	import SortableCategory from '../../../components/app_modules/SortableCategory'

	import SortableProducts from '../../../components/app_modules/SortableProducts.vue'

	import FormList from '../../../components/app_modules/FormList'

	import Forms from '../../../components/app_modules/Forms'
	import Editor from '../../../components/app_modules/Editor'
	//import SortableCategory from '../../../../components/app_modules/SortableCategory'

	import axios from 'axios'

	export default {
		name: 'shop-category-create',

		
		data() {
			return {
				productPage: true,
				modalCreateFolder: false,
				openForms:false,
				//serverErrors: null,

				www: {
					link_send: this.$store.getters.getDomainName+'soft/type',
					method: 'post',
					redirect: 'soft-type',

					title: '',
					link: '',
					poss: '',
					status: 'true',
					options: [],
					images: [],

				},
				formElements: [
				{
					id: 0,
					type: 'input',
					name: 'Title',
					placeholder: 'title',
					model: '',
					readonly: true
				},
				
				{
					id: 1,
					type: 'input',
					name: 'poss',
					placeholder: 'Позиция',
					model: '',
					readonly: true
				},
				{
					id: 2,
					type: 'status',
					name: 'status',

					model: true,
				},
				
				],

				scrollTo: [
				{
					id: 1,
					name: 'Лого',
					href: '#s1',
				},
				{
					id: 2,
					name: 'Мета дани',
					href: '#s2',
				},
				
				]
			}
		},
		methods: {

			// exportOptions(data) {
			// 	this.www.options = data

			// }, 

			exportContent(data) {
				this.www.description = data

			},
			
			exportMeta(data) {
				console.log(data)

				this.www.title = data[0].model
				this.www.poss = data[1].model
				this.www.status = data[2].model
			},
			
			exportImages(data) {

				this.www.images = data
			}
			
		},
		created() {
			eventBus.$on('closeModalCreateFolder', data => {
				this.modalCreateFolder = data
			})
			

			if(this.$route.name == 'soft-type-edit') {

				axios.get(this.$store.getters.getDomainName+'soft/type/'+this.$route.params.id+'/edit')

				.then(response => {
					this.www.title = response.data['title']
					this.www.poss = response.data['poss']
					this.www.status = response.data['status']
					// this.www.options = response.data['options']

					var images =  response.data['images'].split(";")
					images = images.reverse()

					for (var i = images.length - 1; i >= 0; i--) {
						if(images[i] != '') {
							this.www.images.push({ 
								icon: images[i],
								id: i,
							})
						}
					}


					this.formElements[0].model = response.data['title']
					this.formElements[1].model = response.data['poss']



					response.data['status'] == 0 ? this.formElements[2].model = false : this.formElements[2].model = true


					// if(response.data['status'] == 0) {
					// 	this.formElements[6].model = false
					// } else {
					// 	this.formElements[6].model = true
					// }



					this.www.link_send = this.$store.getters.getDomainName+'soft/type/'+this.$route.params.id
					this.www.method = 'patch'


					eventBus.$emit('sendLinkAndMethod', this.www)

					this.openForms = true
					return


				})
				.catch(error => {
					
				})

				
			} else {
				this.openForms = true
			}
		},
		beforeDestroy() {
			eventBus.$off('closeModalCreateFolder')
		},
		components: {
			ModalCreateFolder,
			Forms,
			ScrollTo,
			Editor,
			//SortableCategory,
			Errors,
			BottomMenu,
			SortableImages,
			SortableCategory,
			SortableProducts,
			FormList
		},

	}
</script>

<style scoped src="../../../assets/css/page-data.css"></style>


// WEBPACK FOOTER //
// src/components/soft/type/data.vue